module.exports = __webpack_public_path__ + "img/service-banner8.5155836e.png";